import { FC, CSSProperties } from 'react';

type ExportIconProps = {
  style?: CSSProperties;
  className?: string;
};

const ExportIcon: FC<ExportIconProps> = ({ style, className }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={ style }
      className={ className }
    >
      <path
        // eslint-disable-next-line max-len
        d="M8.125 9.8335V1.8335M8.125 1.8335L11.125 4.8335M8.125 1.8335L5.125 4.8335M15.625 9.16683V12.1668C15.625 12.6973 15.4143 13.206 15.0392 13.581C14.6641 13.9561 14.1554 14.1668 13.625 14.1668H2.625C2.09457 14.1668 1.58586 13.9561 1.21079 13.581C0.835714 13.206 0.625 12.6973 0.625 12.1668V9.16683"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ExportIcon;
